import { createTheme } from '@mui/material/styles';
import { ptBR } from '@mui/material/locale';

import COLORS from '../utils/colors';

export default createTheme(
  {
    breakpoints: {
      values: {
        mobile: 0,
        tablet: 640,
        laptop: 1024,
        desktop: 1280,
        largedesktop: 1680,
      },
    },

    typography: {
      fontFamily: ['Noto Sans', ' sans-serif'].join(','),
    },

    palette: {
      primary: {
        main: COLORS.actionOrange,
        light: COLORS.hoverOrange,
      },
      secondary: {
        main: COLORS.actionOrange,
        light: COLORS.hoverOrange,
      },
      error: {
        main: COLORS.redWarning,
      },
      background: {
        default: COLORS.background,
      },
    },
  },

  ptBR,
);
